import { useContext } from 'react';
import { AuthContext, IAuth, Rotina } from '../context/Auth';
import Inicio from '../pages/Inicio';
import { Route, Routes } from 'react-router-dom';
import App from '../pages/App/App';
import Cargo from '../pages/Cadastros/Cargo';
import CargoMembro from '../pages/Cadastros/CargoMembro';
import GrupoSede from '../pages/Cadastros/GrupoSede';
import GrupoCargo from '../pages/Cadastros/GrupoCargo';
import PerfilMembro from '../pages/Cadastros/PerfilMembro';
import Membros from '../pages/Batismo/Membros/index';
import Presenca from '../pages/Batismo/Presenca/index';
import Dash from '../pages/Batismo/Dash/index';
import Sede from '../pages/Cadastros/Sede';
import GrupoCelula from '../pages/Cadastros/GrupoCelula';
import Atividade from '../pages/Cadastros/Atividade';
import DashCheckin from '../pages/Checkin/Dash';
import MembrosCheckin from '../pages/Checkin/Membros';
import MembrosCursos from '../pages/Cursos/Membros';

import Eventos from '../pages/Batismo/eventos';
import EventosCheckin from '../pages/Checkin/Eventos';
import EventosCRM from '../pages/crm/principal';
import DashboardCRM from '../pages/crm/dash';
import GrupoMinisterio from '../pages/Cadastros/GrupoMinisterio';
import Permissoes from '../pages/Cadastros/Permissoes';
import Mensagens from '../pages/Acolher/Mensagens';
import DashHistorico from '../pages/Batismo/DashHistorico';

import { Routes as RoutesPg } from '../pages/Pg/routes';
import Layout from '../components/layout';
import LoadingGif from '../components/loading';
import EditarEventoBatismo from '../pages/Batismo/eventos/children/edit';
import AlocarBatismo from '../pages/Batismo/Presenca/children/alocarBatismo';
import EditMembroBatismo from '../pages/Batismo/Membros/children/edit/edit';
import { EditPage } from '../pages/Checkin/Eventos/children/edit';
import EditComponent from '../pages/Acolher/Mensagens/children/edit';
import AddSede from '../pages/Cadastros/Sede/components/crudSede';
import { User } from '../pages/crm/usuarios';
import { GrupoSedeAdd } from '../pages/Cadastros/GrupoSede/children/add';
import { GrupoSedeEdit } from '../pages/Cadastros/GrupoSede/children/edit';
import { GrupoMinisterioAdd } from '../pages/Cadastros/GrupoMinisterio/children/add';
import { GrupoMinisterioEdit } from '../pages/Cadastros/GrupoMinisterio/children/edit';
import { GrupoCelulaAdd } from '../pages/Cadastros/GrupoCelula/children/add';
import { GrupoCelulaEdit } from '../pages/Cadastros/GrupoCelula/children/edit';
import { GrupoCargoAdd } from '../pages/Cadastros/GrupoCargo/children/add';
import { GrupoCargoEdit } from '../pages/Cadastros/GrupoCargo/children/edit';
import { CargoAdd } from '../pages/Cadastros/Cargo/children/add';
import { CargoEdit } from '../pages/Cadastros/Cargo/children/edit';
import { PerfilMembroAdd } from '../pages/Cadastros/PerfilMembro/children/add';
import { PerfilMembroEdit } from '../pages/Cadastros/PerfilMembro/children/edit';
import { AtividadeAdd } from '../pages/Cadastros/Atividade/children/add';
import { AtividadeEdit } from '../pages/Cadastros/Atividade/children/edit';
import { EditSede } from '../pages/Cadastros/Sede/children/edit';

export default function Router() {
  const { auth, usuarioRotinas } = useContext<IAuth>(AuthContext);

  const rotina = (usuarioRotinas||[])?.map((rotina: Rotina) => rotina?.nomerotina)

  return (
    <Routes>
      {
        auth
          ?
          <>
            <Route path="/" element={<Layout />} loader={() => <LoadingGif />}>
              <Route path="/dash" element={<Inicio />} />

              {
                rotina?.some((rotina: string) => rotina == "Sede") ?
                  <Route path="/dash/cadastro/sede" element={<Sede />} >
                    <Route path="add" element={<AddSede />} />
                    <Route path=":id/edit" element={<EditSede />} />
                  </Route>
                  : false
              }
              {

                <Route path="/dash/usuario/:id" element={<User />} />

              }
              {
                rotina?.some((rotina: string) => rotina == "Cargo") ?
                  <Route path="/dash/cadastro/cargo" element={<Cargo />} >
                    <Route path="add" element={<CargoAdd />} />
                    <Route path=":id" element={<CargoEdit />} />
                  </Route>
                  : false
              }
              {/* {
                rotina?.some((rotina: string) => rotina == "Cargo do usuario") ?
                  <Route path="/dash/cadastro/cargoMembro" element={<CargoMembro />} />
                  : false
              } */}

              {
                rotina?.some((rotina: string) => rotina == "Grupo de Celula") ?
                  <Route path='/dash/cadastro/grupocelula' element={<GrupoCelula />} >
                    <Route path='add' element={<GrupoCelulaAdd />} />
                    <Route path=':id' element={<GrupoCelulaEdit />} />
                  </Route>
                  : false
              }

              {
                rotina?.some((rotina: string) => rotina == "Grupo de Sede") ?
                  <Route path="/dash/cadastro/gruposede" element={<GrupoSede />} >
                    <Route path="add" element={<GrupoSedeAdd />} />
                    <Route path=":id" element={<GrupoSedeEdit />} />
                  </Route>
                  : false
              }

              {
                rotina?.some((rotina: string) => rotina == "Grupo de Cargo") ?
                  <Route path="/dash/cadastro/grupocargo" element={<GrupoCargo />} >
                    <Route path="add" element={<GrupoCargoAdd />} />
                    <Route path=":id" element={<GrupoCargoEdit />} />
                  </Route>
                  : false
              }
              {
                rotina?.some((rotina: string) => rotina == "Perfil de Membro") ?
                  <Route path="/dash/cadastro/perfilmembro" element={<PerfilMembro />} >
                    <Route path="add" element={<PerfilMembroAdd />} />
                    <Route path=":id" element={<PerfilMembroEdit />} />
                  </Route>
                  : false
              }

              {
                rotina?.some((rotina: string) => rotina == "Atividade") ?
                  <Route path="/dash/cadastro/atividade" element={<Atividade />} >
                    <Route path="add" element={<AtividadeAdd />} />
                    <Route path=":id" element={<AtividadeEdit />} />
                  </Route >
                  : false
              }

              {
                rotina?.some((rotina: string) => rotina == "Membros Cadastrados") ?
                  <Route path="/dash/batismo/membros" element={<Membros />} >
                    <Route path="edit/:id" element={<EditMembroBatismo />} />
                  </Route>
                  : false
              }
              {
                rotina?.some((rotina: string) => rotina == "Presença Batismo") ?
                  <Route path="/dash/batismo/presenca" element={<Presenca />} >
                    <Route path="alocar" element={<AlocarBatismo />} />
                  </Route>
                  : false
              }
              {
                rotina?.some((rotina: string) => rotina == "Dashboard Batismo") ?
                  <Route path="/dash/batismo/dashbatismo" element={<Dash />} />
                  : false
              }


              <>
                <Route path={'/dash/batismo/history'} element={<DashHistorico />} />
              </>
              {
                rotina?.some((rotina: string) => rotina == "Mensagens") ?
                  <>
                    <Route path={'/dash/acolher/mensagens'} element={<Mensagens />} >
                      <Route path={'edit/:id'} element={<EditComponent />} />
                    </Route>
                  </>
                  : false
              }

              {
                rotina?.some((rotina: string) => rotina == "Ministerio") ?
                  <Route
                    path="/dash/cadastro/ministerio"
                    element={< GrupoMinisterio />}
                  >
                    <Route
                      path="add"
                      element={< GrupoMinisterioAdd />}
                    />
                    <Route
                      path=":id"
                      element={< GrupoMinisterioEdit />}
                    />

                  </Route>
                  : false
              }

              {/* {
                rotina?.some((rotina: string) => rotina == "Permissão") ?
                  <Route
                    path="/dash/cadastro/permissoes"
                    element={< Permissoes />}
                  />
                  : false
              } */}

              {
                rotina?.some((rotina: string) => rotina == "Dashboard Check-in") ?
                  <Route path="/dash/checkin/dashboard" element={< DashCheckin />} />
                  :
                  false
              }
              {
                rotina?.some((rotina: string) => rotina == "Lista de Membros") ?
                  <Route path="/dash/checkin/membros" element={< MembrosCheckin />} />
                  : false
              }
              {
                rotina?.some((rotina: string) => rotina == "Evento Check-in") ?
                  <Route path="/dash/checkin/eventos" element={<EventosCheckin />} >
                    <Route path="edit/:id" element={<EditPage />} />
                  </Route>
                  : false
              }

              {
                rotina?.some((rotina: string) => rotina == "Curso Lideres") ?
                  <Route path="/dash/cursos/membros" element={<MembrosCursos />} />
                  : false
              }



              {
                rotina?.some((rotina: string) => rotina == "Dashboard CRM") ?
                  <Route path="/dash/crm/dash" element={< DashboardCRM />} />
                  : false
              }
              {
                rotina?.some((rotina: string) => rotina == "Lista de Membros") ?
                  <Route path="/dash/crm/membros" element={< EventosCRM />} />
                  : false
              }

              {
                rotina?.some((rotina: string) => rotina == "Evento Batismo") ?
                  <Route path="/dash/batismo/eventos" element={<Eventos />}>

                    <Route path="/dash/batismo/eventos/edit/:id" element={<EditarEventoBatismo />} />

                  </Route>

                  : false
              }

              {
                RoutesPg()
              }

              {/* <Route path="*" element={<App />} /> */}
            </Route>
          </>
          :
          <Route path="*" element={<App />} />
      }
    </Routes >
  )
}
